/**
 * useHydrated
 *
 * Returns `true` only after React has fully hydrated on the client side.
 * Use this to safely guard interactive UI that must not run during SSR
 * or before the JS bundle has executed (e.g. form submit buttons).
 *
 * Safe with TanStack Start's SSR because `useEffect` never runs on the server.
 */
import { useEffect, useState } from "react";

export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    // This effect only runs on the client, after React has mounted.
    setHydrated(true);
  }, []);

  return hydrated;
}
